/**
 * Apply conditional properties to an object
 *
 * @param {Array} conditionalProps - the array of conditional props
 * @returns {object} the result
 */
const conditionalProperties = conditionalProps =>
  conditionalProps.reduce((obj, [condition, props]) => {
    if (condition) {
      obj = { ...obj, ...props }
    }

    return obj
  }, {})

export default conditionalProperties
